/* ============================================
   KOMPONEN: Progress Bar
   ============================================ */
   export const ProgressBarLogistic = ({ value, max, color = "cyan" }) => {
    const pct = max > 0 ? Math.min((value / max) * 100, 100) : 0;
    const colors = {
      cyan: { bar: "bg-cyan-500", bg: "bg-cyan-500/10", glow: "shadow-cyan-500/30" },
      blue: { bar: "bg-blue-500", bg: "bg-blue-500/10", glow: "shadow-blue-500/30" },
      amber: { bar: "bg-amber-500", bg: "bg-amber-500/10", glow: "shadow-amber-500/30" },
      orange: { bar: "bg-orange-500", bg: "bg-orange-500/10", glow: "shadow-orange-500/30" },
      red: { bar: "bg-red-500", bg: "bg-red-500/10", glow: "shadow-red-500/30" },
      emerald: { bar: "bg-emerald-500", bg: "bg-emerald-500/10", glow: "shadow-emerald-500/30" },
    };
    const c = colors[color] || colors.cyan;
    return (
      <div className={`w-full h-2 rounded-full ${c.bg} overflow-hidden`}>
        <div
          className={`h-full rounded-full ${c.bar} shadow-sm ${c.glow} transition-all duration-700`}
          style={{ width: `${pct}%` }}
        />
      </div>
    );
  };